<template>
  <div id="app">
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<script>
let height
const sendPostMessage = () => {
  if (height !== document.getElementById('app').offsetHeight) {
    height = document.getElementById('app').offsetHeight
    window.parent.postMessage({
      frameHeight: height
    }, '*');
    console.log(height) // check the message is being sent correctly
  }
}

let lastErrorTime = 0

export default {
  name: 'App',
  data() { return {
    state: this.$store.state
  }},
  mounted() {
    this.$http.interceptors.response.use((response) => {
      return response
    }, async (error) => {
      let thisErrorTime = new Date().getTime()
      if (thisErrorTime - lastErrorTime < 1000 && lastErrorTime != 0) {
        lastErrorTime = thisErrorTime
        return
      }
      lastErrorTime = thisErrorTime
      if (error.response) {
        try {
          await this.$http.post(this.state.app.apiUrl + '/errorlog', {type:'frontend', browser: navigator.userAgent, error: JSON.stringify(error.response)})
        } catch(err) {
          console.log(err)
        }
      }
      return Promise.reject(error)
    })


    if (this.$route.query.event) {
      this.$router.push({name: 'Event', params: {id: this.$route.query.event}})
    }
    window.onload = () => sendPostMessage();
    window.onresize = () => sendPostMessage();
    setTimeout(() => {
      sendPostMessage()
      console.log("post message")
    },300)
  },
  watch: {
    '$route' (to, from) {
      setTimeout(() => {
        sendPostMessage()
        console.log("post message")
      },300)
    }
  },
  computed: {
    
  },
  methods: {
  }
}
</script>

<style lang="stylus">
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;600;700&display=swap');
body {
  background: var(--tnm-page-background, #ffffff)
}
//@import url('/static/matter-0.2.2.min.css');
.full-height {
  height:100%
}
.nomargin {
  margin:0px!important
}
.relative {
  position:relative
}
figure {
  img {
    max-width:100%!important;
  }
  &.image-style-align-right {
    float:right;
    padding-left:15px;
  }
  &.image-style-align-left {
    float:left;
    padding-right:15px;
  }
  &.image-style-align-center {
    left:0;
    right:0;
    margin: 0 auto;
  }
}
</style>
